export default __webpack_public_path__ + "static/media/dropbox-original.b424fe33.svg";